import React, { useCallback } from "react";
import PropTypes from "prop-types";
import EntitiesSelector, { commonPropTypes } from "./entities-selector";
import {EXTENDED_SELECT_LIMIT} from "./utils/select-constants";

const query = `
  query Users($offset: Int, $limit: Int, $includePartnerUsers: Boolean) {
    users(offset: $offset, limit: $limit, includePartnerUsers: $includePartnerUsers) {
      items {
        id
        username
      }
      total
    }
  }
`;

const UserSelect = ({
  excludePartnerUsers = false,
  multiple = false,
  id = "userId",
  name = "userId",
  isInsideForm,
  value,
  ...props
}) => {
  const handleDataFromResponse = useCallback(data => data.users, []);
  const handleGetValue = useCallback(element => element.id, []);
  const handleGetLabel = useCallback(element => element.username, []);

  return value ? (
    <EntitiesSelector
      multiple={multiple}
      isInsideForm={isInsideForm}
      id={id}
      name={name}
      queryString={query}
      onGetDataFromResponse={handleDataFromResponse}
      onGetValue={handleGetValue}
      onGetLabel={handleGetLabel}
      variables={{
        customerId: undefined,
        username: undefined,
        includePartnerUsers: !excludePartnerUsers,
      }}
      value={value}
      limit={EXTENDED_SELECT_LIMIT}
      {...props}
    />
  ) : null;
};

UserSelect.propTypes = {
  ...commonPropTypes,
  /**
   * Indica si deben excluirse los usuarios partner.
   */
  excludePartnerUsers: PropTypes.bool,
};

export default UserSelect;
